import React from "react";
import ceoImage from "../assets/img/CEOImage.jpeg";
import aboutImageOne from "../assets/img/About1.jpeg";
import aboutImageTwo from "../assets/img/About2.jpeg";

export const AboutPage: React.FC = () => {
  return (
    <main>
      <section className="relative pt-xl pb-lg overflow-hidden bg-white">
        <div className="max-w-container-max mx-auto px-lg grid grid-cols-1 lg:grid-cols-2 gap-lg items-center">
          <div className="z-10">
            <span className="text-secondary font-label-md tracking-widest uppercase mb-sm block">
              Founded in 2020
            </span>
            <h1 className="font-display-lg text-display-lg text-primary mb-md leading-tight text-balance">
              Trusted Cleaning and Pest Control
            </h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant mb-lg max-w-xl">
              Kolomaka Cleaning Services is a trusted and professional service
              provider specializing in cleaning and pest control solutions.
              Established in 2020 in Limpopo Province, South Africa, we serve
              residential and commercial clients with reliable, efficient, and
              high-quality services that keep spaces clean, safe, and hygienic.
            </p>
          </div>
          <div className="relative">
            <div className="space-y-md">
              <div className="aspect-square bg-surface-container-low rounded-xl overflow-hidden relative shadow-md">
                <img
                  className="w-full h-full object-cover"
                  data-alt="Mologadi Malahlela, Founder and Director of Kolomaka Cleaning Services"
                  src={ceoImage}
                  alt="Mologadi Malahlela"
                  loading="lazy"
                  decoding="async"
                  fetchPriority="low"
                />
              </div>
              <div className="bg-surface-container-lowest border border-outline-variant rounded-xl p-lg shadow-sm">
                <h2 className="font-headline-md text-headline-md text-primary mb-sm">
                  Meet Our Director - Mologadi Malahlela
                </h2>
                <p className="font-body-md text-body-md text-on-surface-variant mb-sm">
                  Mologadi Malahlela is the Founder and Director of Kolomaka
                  Cleaning Services, a proudly South African company providing
                  professional cleaning and integrated pest control solutions.
                  She established the business with a vision to create clean,
                  healthy, and safe environments through exceptional service and
                  customer satisfaction.
                </p>
                <p className="font-body-md text-body-md text-on-surface-variant mb-sm">
                  While working with clients, Mologadi recognised that many
                  spaces requiring cleaning also faced persistent pest problems.
                  This insight led her to expand the business into professional
                  pest management, enabling clients to access comprehensive
                  cleaning and pest control services from one trusted provider.
                </p>
                <p className="font-body-md text-body-md text-on-surface-variant mb-sm">
                  Committed to continuous learning and industry best practices,
                  Mologadi ensures that Kolomaka Cleaning Services delivers
                  safe, effective, and compliant solutions. Under her
                  leadership, the company offers commercial and residential
                  cleaning, post-construction cleaning, deep cleaning, pest
                  control, termite treatments, and hygiene services.
                </p>
                <p className="font-body-md text-body-md text-on-surface-variant mb-sm">
                  Her vision is to make Kolomaka Cleaning Services one of
                  Limpopo&apos;s most trusted cleaning and pest management
                  companies while creating healthier spaces, building lasting
                  client relationships, and contributing to local job creation.
                </p>
                <p className="font-body-lg text-body-lg text-primary font-medium italic">
                  “At Kolomaka Cleaning Services, we don&apos;t just clean
                  spaces—we create healthier, safer, and pest-free environments.
                  Clean is within our name!”
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-xl bg-surface-container-lowest">
        <div className="max-w-container-max mx-auto px-lg">
          <div className="text-center mb-lg">
            <h2 className="font-headline-lg text-headline-lg text-primary mb-sm">
              Our Mission and Vision
            </h2>
            <p className="font-body-md text-body-md text-on-surface-variant">
              Built on professionalism, quality, and customer satisfaction.
            </p>
          </div>
          <div className="bento-grid grid-cols-1 md:grid-cols-12 md:grid-rows-2 gap-md h-auto md:h-[600px]">
            <div className="md:col-span-4 md:row-span-2 bg-white border border-outline-variant p-lg flex flex-col justify-center items-center text-center group hover:border-secondary transition-colors">
              <div className="w-16 h-16 rounded-full bg-secondary-container flex items-center justify-center text-secondary mb-md group-hover:scale-110 transition-transform">
                <span className="material-symbols-outlined text-4xl">
                  verified_user
                </span>
              </div>
              <h3 className="font-headline-md text-headline-md text-primary mb-sm">
                Professionalism
              </h3>
              <p className="text-on-surface-variant font-body-md">
                We deliver services with integrity and respect, maintaining a
                professional standard in every interaction.
              </p>
            </div>

            <div className="md:col-span-8 md:row-span-1 bg-brand-gradient text-on-primary p-lg flex flex-col justify-center relative overflow-hidden">
              <div className="z-10">
                <h3 className="font-headline-md text-headline-md mb-sm text-secondary-fixed">
                  Our Mission
                </h3>
                <p className="font-headline-lg text-headline-lg text-white max-w-2xl text-balance">
                  "To provide dependable, high-quality cleaning and pest control
                  services that promote healthy and comfortable living and
                  working environments."
                </p>
              </div>
              <div className="absolute top-0 right-0 p-lg opacity-20 pointer-events-none">
                <span className="material-symbols-outlined text-[120px]">
                  format_quote
                </span>
              </div>
            </div>

            <div className="md:col-span-4 md:row-span-1 bg-surface-container-low border border-outline-variant p-md flex items-start gap-md group">
              <span className="material-symbols-outlined text-secondary text-3xl">
                sanitizer
              </span>
              <div>
                <h3 className="font-headline-md text-headline-md text-primary mb-xs">
                  Quality
                </h3>
                <p className="text-on-surface-variant font-body-md">
                  We maintain high standards in every task we undertake, from
                  routine cleaning to pest control.
                </p>
              </div>
            </div>

            <div className="md:col-span-4 md:row-span-1 bg-surface-container-low border border-outline-variant p-md flex items-start gap-md group">
              <span className="material-symbols-outlined text-secondary text-3xl">
                task_alt
              </span>
              <div>
                <h3 className="font-headline-md text-headline-md text-primary mb-xs">
                  Customer Satisfaction
                </h3>
                <p className="text-on-surface-variant font-body-md">
                  Our clients' needs are our top priority, and we tailor every
                  service to match the job at hand.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-xl bg-white">
        <div className="max-w-container-max mx-auto px-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-xl items-center">
            <div className="order-2 lg:order-1">
              <div className="grid grid-cols-2 gap-md">
                <div className="pt-lg">
                  <div className="aspect-[3/4] bg-surface-variant overflow-hidden shadow-md">
                    <img
                      className="w-full h-full object-cover"
                      data-alt="Pest control technician"
                      src={aboutImageOne}
                      alt="Pest control"
                      loading="lazy"
                      decoding="async"
                      fetchPriority="low"
                    />
                  </div>
                </div>
                <div>
                  <div className="aspect-[3/4] bg-surface-variant overflow-hidden shadow-md">
                    <img
                      className="w-full h-full object-cover"
                      data-alt="Carpet steam cleaning"
                      src={aboutImageTwo}
                      alt="Carpet"
                      loading="lazy"
                      decoding="async"
                      fetchPriority="low"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="font-display-lg text-display-lg text-primary mb-md leading-tight">
                Services Designed for Homes and Businesses
              </h2>
              <div className="space-y-md">
                <div className="flex items-start gap-md">
                  <div className="mt-1 flex-shrink-0">
                    <span className="material-symbols-outlined text-secondary font-bold">
                      check_circle
                    </span>
                  </div>
                  <div>
                    <h4 className="font-headline-md text-headline-md text-primary">
                      Residential Cleaning, Deep Cleaning & Hygiene Services
                    </h4>
                    <p className="text-on-surface-variant">
                      Thorough, reliable cleaning services including deep
                      cleaning and hygiene solutions that keep homes fresh,
                      comfortable, and sanitized.
                    </p>
                  </div>
                </div>
                <hr className="border-outline-variant" />
                <div className="flex items-start gap-md">
                  <div className="mt-1 flex-shrink-0">
                    <span className="material-symbols-outlined text-secondary font-bold">
                      check_circle
                    </span>
                  </div>
                  <div>
                    <h4 className="font-headline-md text-headline-md text-primary">
                      Commercial & Office Cleaning
                    </h4>
                    <p className="text-on-surface-variant">
                      Dependable cleaning solutions that support professional,
                      hygienic business environments.
                    </p>
                  </div>
                </div>
                <hr className="border-outline-variant" />
                <div className="flex items-start gap-md">
                  <div className="mt-1 flex-shrink-0">
                    <span className="material-symbols-outlined text-secondary font-bold">
                      check_circle
                    </span>
                  </div>
                  <div>
                    <h4 className="font-headline-md text-headline-md text-primary">
                      Pest Control
                    </h4>
                    <p className="text-on-surface-variant">
                      Safe and effective pest management solutions designed to
                      protect your home and business from unwanted pests.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutPage;
